import { BaseSyntheticEvent, KeyboardEventHandler } from 'react';
import { isInternetExplorer } from '../../tools/ie-hacks';

const { arrowUp, arrowDown, isIe } = getEventKeyConstants();

export interface HpAddAutoCompleteKeyboardNavigationHandlerProps {
  controlContainerCssSelector: string;
  controlItemCssSelector: string;
  jQuery: JQueryStatic;
  noMatchKey?: string;
  window: Window;
}

export function addKeyboardNavigationHandler({
  window,
  controlContainerCssSelector,
  controlItemCssSelector,
  noMatchKey,
  jQuery: $
}: HpAddAutoCompleteKeyboardNavigationHandlerProps): void {
  const handler: KeyboardEventHandler = (ev) => {
    const target = ev.target as HTMLElement;
    const list = target ? $(target).closest(controlContainerCssSelector) : [];
    if (list.length > 0) {
      const { key } = ev;
      const items = $(controlItemCssSelector, list).toArray();
      const focusIx = items.findIndex((m) => $(m).is(':focus'));

      if (noMatchKey && items.length === 1 && $(items[0]).hasClass(noMatchKey)) {
        return;
      }

      if (key === arrowUp || key === arrowDown) {
        ev.preventDefault();

        if (isIe && !$(items).is(':visible')) {
          if (target && target.click) {
            target.click();
            return;
          }
        }

        const isDown = key === arrowDown;
        const nextIx = focusIx < 0 ? 0 : focusIx + (isDown ? 1 : -1);
        const item = items[nextIx];
        if (item) {
          item.focus();
        }
      } else if (focusIx >= 0 && (key === ' ' || key === 'Enter')) {
        ev.preventDefault();
        items[focusIx].click();
      }
    }
  };

  window.addEventListener('keydown', handler as any, false);
}

export function createSpaceKeyAsClickHandler<EventT extends BaseSyntheticEvent>(
  onClick: (event: EventT) => void,
  additionalHandler?: HpAdditionalKeyboardHandler
): KeyboardEventHandler {
  const handler: KeyboardEventHandler = (event) => {
    const { key } = event;
    if (key === ' ' || key === 'Enter') {
      event.preventDefault(); // stop 'space' from incrementing down the page.
      $(event.target).removeClass('hide-focus-visible');
      (event as any).keepFocusVisible = true;
      onClick(event as any);
    } else if (additionalHandler) {
      additionalHandler(key, event);
    }
  };

  return handler;
}

export function getEventKeyConstants(): HpGetKeyConstantsResult {
  const isIe = isInternetExplorer();
  if (isIe) {
    return { isIe, arrowDown: 'Down', arrowUp: 'Up' };
  }

  return { isIe, arrowUp: 'ArrowUp', arrowDown: 'ArrowDown' };
}

export type HpAdditionalKeyboardHandler = (key: string, event: React.KeyboardEvent<Element>) => void;

interface HpGetKeyConstantsResult {
  arrowDown: string;
  arrowUp: string;
  isIe: boolean;
}
